module.exports = __webpack_public_path__ + "static/media/arrow-rewards.96e1cf5f.svg";